import React, { Component } from 'react';
import { withRouter } from 'react-router';

import Step2PreUpload from './Step2PreUpload';
import Step2SuccessUpload from './Step2SuccessUpload';

// Entry point for the BIN Step 2 in DIY
class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadState: 'new'
    };
  }

  // The upload was successful - move to the "success" state
  handleUpload = (lots, spreadsheetErrors, spreadsheetWarnings) => {
    this.setState({
      lots,
      spreadsheetErrors,
      spreadsheetWarnings,
      uploadState: 'success'
    });
  };

  // Reset the state back to 'new' so the user can upload a new spreadsheet
  goBackToUpload = () => {
    this.setState(
      {
        lots: null,
        uploadState: 'new'
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    const { lots, spreadsheetErrors, spreadsheetWarnings, uploadState } = this.state;

    if (uploadState === 'success') {
      return (
        <Step2SuccessUpload
          goBackToUpload={this.goBackToUpload}
          lots={lots}
          spreadsheetErrors={spreadsheetErrors}
          spreadsheetWarnings={spreadsheetWarnings}
        />
      );
    }

    return <Step2PreUpload handleUpload={this.handleUpload} />;
  }
}

export default withRouter(Step2);
